import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AUTOMATED_PRISM_USER, ClientDevice, User, UserNotification, UserSessionData } from '@prism/prism-shared';
import { CoreState } from './core.reducer';

export const coreState = createFeatureSelector<CoreState>('core');

export const getLoadingState = createSelector(
  coreState,
  (state: CoreState): number => state.loadingState
);

export const getError = createSelector(
  coreState,
  (state: CoreState): any => state.error
);

export const getCurrentUser = createSelector(
  coreState,
  (state: CoreState): User => state.currentUser as User
);

export const getUsers = createSelector(
  coreState,
  (state: CoreState): User[] => [...state.users].sort((a, b) => a.firstName.localeCompare(b.firstName))
);

export const getCurrentClientDevice = createSelector(
  coreState,
  (state: CoreState): ClientDevice | null => state.currentClientDevice
);

export const getUserSessionData = createSelector(
  coreState,
  (state: CoreState): UserSessionData => state.userSessionData,
)

export const getUserNotifications = createSelector(
  coreState,
  (state: CoreState): UserNotification[] => state.userNotifications
)

// above are selectors that ONLY use coreState
// =========================================================
// below are selectors that are built with selectors above

export const getUsersWithSystem = createSelector(
  getUsers,
  (users: User[]): User[] => [
    ...users,
    AUTOMATED_PRISM_USER
  ]
);

export function getUserById(userId: string) {
  return createSelector(
    getUsers,
    (users: User[]): User | null => users.find(user => user.id === userId) || null
  );
}

export const getUsersDict = createSelector(
  getUsers,
  (users: User[]): Record<string, User> => users.reduce((acc, user) => {
    acc[user.id] = user;
    return acc;
  }, {} as Record<string, User>)
);

export const getUserFullNameDict = createSelector(
  getUsers,
  (users: User[]): Record<string, string> => users.reduce((acc, user) => {
    acc[user.id] = `${user.firstName} ${user.lastName}`;
    return acc;
  }, {} as Record<string, string>)
);




